// @ts-nocheck
import { Fragment, useEffect, useRef, useState } from 'react';
import { Menu, Switch, Transition } from '@headlessui/react';
import { useAppDispatch } from '../../../../app/hooks';
import { CreateReviewPayload, ReviewData, ReviewResponse } from '../../../review/reviewTypes';
import { toast } from 'sonner';
import { createReview, fetchReviewList, fetchReviewDetailsData, updateReview } from '../../../review/reviewSlice';
import { ChevronDownIconWhite, CustomCheckIcon } from '../../../../components/icons';
import { Link, useNavigate, useParams } from 'react-router-dom';

interface BoardPageProps {
    editBoardData?: any;
    onSaveSuccess?: () => void;
}


const CreateReview: React.FC<BoardPageProps> = ({ editBoardData,
    onSaveSuccess }) => {
    const [name, setName] = useState('');
    const [purpose, setPurpose] = useState('');
    const [color, setColor] = useState('bg-[#3b82f6]');
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useAppDispatch();
    const [baseTeamsData, setBaseTeamsData] = useState<any[]>([]);
    const baseIdString = localStorage.getItem('UserBaseId') || localStorage.getItem('createBaseId');
    const baseId = baseIdString ? JSON.parse(baseIdString) : null;
    const [content, setContent] = useState('');
    const { userId } = useParams<{ userId: string }>();
    const [emailData, setEmailData] = useState<ReviewData | null>(null);
    const navigate = useNavigate();
    const [loading1, setLoading1] = useState(false);
    const colorList = [
        { name: "bg-[#3b82f6]" },
        { name: "bg-[#6b7280]" },
        { name: "bg-[#bfdbfe]" },
        { name: "bg-[#ec4899]" },
        { name: "bg-[#6366f1]" },
        { name: "bg-[#eab308]" },
        { name: "bg-[#22c55e]" },
        { name: "bg-[#06b6d4]" },
        { name: "bg-[#dc2626]" },
    ];
    const isEditMode = Boolean(userId);
    const [cursorPosition, setCursorPosition] = useState(0);
    const textAreaRef = useRef<HTMLTextAreaElement>(null);

    // const variables = [
    //     { id: 'candidate_first_name', label: 'Candidate first name', token: '{{CandidateFirstName}}' },
    //     { id: 'candidate_last_name', label: 'Candidate last name', token: '{{CandidateLastName}}' },
    //     { id: 'job_title', label: 'Job title', token: '{{JobTitle}}' },
    // ];

    // Fetch email details when in edit mode
    useEffect(() => {
        const fetchEmailDetails = async () => {
            if (isEditMode && userId && baseId) {
                setLoading1(true);
                try {
                    const response = await dispatch(fetchReviewDetailsData({
                        baseId: Number(baseId),
                        userId
                    }));

                    if (response.payload && typeof response.payload === 'object') {
                        const responseData = response.payload;

                        // Check if we have the email data
                        if (responseData.data && typeof responseData.data === 'object') {
                            const emailDetails = responseData.data;

                            setEmailData({
                                id: Number(emailDetails.id) || 0,
                                review_name: emailDetails.review_name || '',
                                // email_subject: emailDetails.email_subject || '',
                                review_details: emailDetails.review_details || '',
                                colour: emailDetails.colour || '',
                                base_id: Number(emailDetails.base_id) || 0,
                                status: emailDetails.status || '',
                                ai_check: emailDetails.ai_created === 'yes' || ''
                            });

                            // Update form fields
                            setName(emailDetails.review_name || '');
                            // setPurpose(emailDetails.email_subject || '');
                            setContent(emailDetails.review_details || '');
                            // Remove 'bg-[' prefix if it exists in the color value
                            setColor(emailDetails.colour ?
                                emailDetails.colour.startsWith('#') ?
                                    `bg-[${emailDetails.colour}]` :
                                    `bg-[#${emailDetails.colour}]`
                                : 'bg-[#3b82f6]'
                            );
                            setChecked(emailDetails.ai_created === 'yes');
                        } else {
                            console.error('Review details not found in response:', responseData);
                            toast.error('Review template details not found');
                        }
                    } else {
                        console.error('Invalid response payload:', response.payload);
                        toast.error('Failed to load review template data');
                    }
                } catch (error) {
                    console.error('Error fetching review details:', error);
                    toast.error('Failed to fetch review details');
                } finally {
                    setLoading1(false);
                }
            }
        };

        fetchEmailDetails();
    }, [userId, baseId, dispatch, isEditMode]);

    useEffect(() => {
        const storedData = localStorage.getItem('baseReviewData');
        if (storedData) {
            setBaseTeamsData(JSON.parse(storedData));
        }
    }, []);


    // Form submission handler
    const handleSave = async (e?: React.FormEvent) => {
        if (e) {
            e.preventDefault();
        }
        setLoading(true);

        try {
            // Validation
            const validationErrors: string[] = [];

            if (name.trim().length === 0) {
                validationErrors.push("Review Name is required");
            }

            if (content.trim().length === 0) {
                validationErrors.push("Review detail is required");
            }

            if (validationErrors.length > 0) {
                validationErrors.forEach(error => toast.error(error));
                return;
            }

            // Prepare payload
            const colorValue = color.substring(color.indexOf("[#") + 1, color.indexOf("]"));
            const payload: CreateEmailPayload = {
                // base_id: baseId,
                review_name: name,
                // email_subject: purpose,
                colour: colorValue,
                review_details: content,
                ai_created: checked ? 'yes' : 'no' // Add this line
            };

            // Handle update or create
            const action = isEditMode && userId
                ? updateReview({ payload, userId: baseId, id: userId })
                : createReview({ payload, userId: baseId });

            const response = await dispatch(action);

            if (response.meta.requestStatus === 'fulfilled') {
                toast.success(isEditMode ? 'Review template updated successfully!' : 'Review template created successfully!');

                // Update local storage and trigger update
                const baseResponse = await dispatch(fetchReviewList(baseId));
                if (baseResponse?.payload) {
                    localStorage.setItem('baseReviewData', JSON.stringify(baseResponse.payload));
                    window.dispatchEvent(new StorageEvent('storage', {
                        key: 'baseReviewData',
                        newValue: JSON.stringify(baseResponse.payload)
                    }));
                }

                resetForm();
                onSaveSuccess?.();
                navigate(`/${baseId}/settings/reviewtemplate`);
            } else if (response.meta.requestStatus === 'rejected') {
                // Handle specific error messages from the API
                const errorMessage = typeof response.payload === 'string'
                    ? response.payload
                    : 'Failed to save review template';
                toast.error(errorMessage);

            }
        } catch (error) {
            const err = error as Error;
            console.error("Failed to save review template:", err);
            toast.error(err.message || 'An unexpected error occurred');
        } finally {
            setLoading(false);
        }
    };
    const resetForm = () => {
        setName("");
        setPurpose("");
        setContent("")
        setColor("bg-[#3b82f6]");
        setChecked(false);
        // setEditBoardData(null);  // Add this line
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        if (name === 'name') {
            setName(value);
        }
        else if (name === 'purpose') {
            setPurpose(value);
        }
        else if (name === 'content') {
            setContent(value);
        }
    };


    // insert chips 
    const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setContent(e.target.value);
        setCursorPosition(e.target.selectionStart);
    };

    const insertVariable = (token: string) => {
        if (textAreaRef.current) {
            const startPos = textAreaRef.current.selectionStart;
            const endPos = textAreaRef.current.selectionEnd;

            const textBefore = content.substring(0, startPos);
            const textAfter = content.substring(endPos);
            const newContent = `${textBefore}${token}, ${textAfter}`;


            // Update content state
            setContent(newContent);

            // Calculate and set new cursor position
            const newPosition = startPos + token.length;

            setTimeout(() => {
                if (textAreaRef.current) {
                    textAreaRef.current.focus();
                    textAreaRef.current.setSelectionRange(newPosition, newPosition);
                }
            }, 0);
        }
    };


    const handleTextAreaClick = (e: React.MouseEvent<HTMLTextAreaElement>) => {
        const target = e.target as HTMLTextAreaElement;
        setCursorPosition(target.selectionStart);
    };

    const handleTextAreaKeyUp = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        const target = e.target as HTMLTextAreaElement;
        setCursorPosition(target.selectionStart);
    };


    return (
        <div className="max-w-[640px] mx-auto bg-white py-[34px] lg:py-[70px] px-0 h-full">
            <Link to={`/${baseId}/settings/reviewtemplate`}
                className=' flex items-center gap-x-1 w-full mb-4'
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M15 6l-6 6l6 6" />
                </svg>
                <span className='text-black-100 text-[13px]'>
                    Back to listing
                </span>
                {/* <ArrowLeftIcon /> */}
            </Link>
           <h2 className="text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]">
                {isEditMode ? "Edit Review template" : "Create Review template"}
            </h2>
            <form action="#" onSubmit={(e) => e.preventDefault()} className="space-y-6 mt-5">
                <div className='flex flex-col gap-y-2'>
                    <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6'>Review Name</label>
                    <div className="relative">
                        <Menu as='div' className='flex items-center'>
                            <Menu.Button className='absolute inset-y-0 left-0 flex items-center px-2'>
                                <div className={`h-6 w-6 rounded-full ${color} border flex justify-center items-center`}>
                                    <ChevronDownIconWhite />
                                </div>
                            </Menu.Button>
                            <Transition
                                as={Fragment}
                                enter='transition ease-out duration-100'
                                enterFrom='transform opacity-0 scale-95'
                                enterTo='transform opacity-100 scale-100'
                                leave='transition ease-in duration-75'
                                leaveFrom='transform opacity-100 scale-100'
                                leaveTo='transform opacity-0 scale-95'>
                                <Menu.Items className='absolute flex flex-wrap left-0 top-8 z-10 mt-2.5 w-44 p-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none'>
                                    {colorList.map((value, index) => (
                                        <div
                                            onClick={() => setColor(value.name)}
                                            key={index}
                                            className={`flex h-6 w-6 border ${value.name} rounded-full m-2 justify-center items-center cursor-pointer`}
                                        >
                                            {color === value.name && <CustomCheckIcon />}
                                        </div>
                                    ))}
                                </Menu.Items>
                            </Transition>
                            <input
                                id='name'
                                name='name'
                                type='text'
                                value={name}
                                onChange={handleInputChange}

                                className='flex w-full pl-10 grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)]
 focus:ring-indigo-500 transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600   focus:outline 
 focus:outline-2 focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
  border-[#d1d1db]
 dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]'
                            />
                        </Menu>
                    </div>
                    {/* {nameError && <p className="text-sm text-red-600">{nameError}</p>} */}

                    {/* <div className='flex flex-col gap-y-2 mt-1'>
                        <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6'>Template Subject</label>
                        <input
                            id="purpose"
                            name='purpose'
                            type='text'
                            value={purpose}
                            onChange={handleInputChange}
                            className='flex w-full grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)]
                            focus:ring-indigo-500 transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600   focus:outline 
                            focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                             border-[#d1d1db]
                            dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]'
                        />
                        {purposeError && <p className="text-sm text-red-600">{purposeError}</p>}
                    </div> */}
                    <div className='flex flex-col gap-y-1 mt-2'>
                        <div className='flex items-center justify-between'>
                            <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6'>
                                AI Check
                            </label>
                            <Switch
                                checked={checked}
                                onChange={setChecked}
                                className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
                            >
                                <span className="sr-only">Enable AI Check</span>
                                <span aria-hidden="true" className="pointer-events-none absolute size-full rounded-md bg-white" />
                                <span
                                    aria-hidden="true"
                                    className={`pointer-events-none absolute mx-auto h-4 w-9 rounded-full ${checked ? 'bg-indigo-600' : 'bg-gray-200'} transition-colors duration-200 ease-in-out`}
                                />
                                <span
                                    aria-hidden="true"
                                    className={`pointer-events-none absolute ${checked ? 'translate-x-5' : 'translate-x-0'} left-0 inline-block size-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out`}
                                />
                            </Switch>
                        </div>
                        <p className="text-xs text-gray-500">
                            Enable AI assistance to help improve review quality
                        </p>
                    </div>
                    <div className='flex flex-col gap-y-2 mt-1'>
                        <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6'>Review Detail</label>
                        {/* <textarea
                            id="content"
                            name='content'
                            value={content}
                            rows={12}
                            onChange={handleInputChange}
                            className='flex w-full grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)]
                            focus:ring-indigo-500 transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600   focus:outline 
                            focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                             border-[#d1d1db]
                            dark:border-surface-100 focus:outline-indigo-600  rounded-[0.375rem]'
                        /> */}
                        <textarea
                            ref={textAreaRef}
                            value={content}
                            onChange={handleTextAreaChange}
                            onClick={handleTextAreaClick}
                            onKeyUp={handleTextAreaKeyUp}
                            rows={12}
                            className='flex w-full grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)]
            focus:ring-indigo-500 transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600   focus:outline 
            focus:outline-2 focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
             border-[#d1d1db]
            dark:border-surface-100 focus:outline-indigo-600  rounded-[0.375rem]'
                            placeholder="Enter your template content here..."
                        />
                        {/* {contentError && <p className="text-sm text-red-600">{contentError}</p>} */}
                    </div>
                    {/* <div className="flex flex-wrap gap-2">
                        {variables.map((variable) => (
                            <button
                                key={variable.id}
                                onClick={() => insertVariable(variable.token)}
                                className="px-3 py-1 bg-gray-100 rounded-md text-sm hover:bg-gray-200 transition-colors duration-200"
                            >
                                {variable.label}
                            </button>
                        ))}
                    </div> */}
                    <div className="flex justify-end gap-4 mt-6">
                        <button
                            type="button"
                            onClick={resetForm}
                            className="items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-700 bg-white border
                             border-gray-300 rounded-md hover:bg-gray-50"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            onClick={(e) => handleSave(e)}
                            className='group inline-flex shrink-0 w-fit select-none items-center justify-center leading-6 transition-colors
                 duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 items-center px-[14px] py-1 text-[13px] font-medium h-[32px]
                 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 
                 rounded-md text-white outline-indigo-600
                 disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600'
                        >

                            {
                                loading ? (
                                    <div className='flex items-center gap-[6px]'>
                                        {isEditMode ? 'Update Template' : 'Create Template'}
                                        <div className="simple-spinner">
                                            <span></span>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        {isEditMode ? 'Update Template' : 'Create Template'}
                                    </div>
                                )
                            }

                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default CreateReview;